/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Tag200,
  GetApiV1Tag401,
  GetApiV1Tag500,
  GetApiV1TagQueryParams,
  GetApiV1TagQueryResponse,
} from "../../types/tagRegistroController/GetApiV1Tag.ts";
import { tagListItemViewModelPaginatedResponseSchema } from "../tagListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1TagQueryParamsSchema = z.object({
  companyId: z.optional(z.coerce.number().int()),
  filter: z.optional(z.string()),
  active: z.optional(z.boolean()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1TagQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Tag200Schema = z.lazy(
  () => tagListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Tag200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Tag401Schema = z.any() as unknown as ToZod<GetApiV1Tag401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Tag500Schema = z.any() as unknown as ToZod<GetApiV1Tag500>;

export const getApiV1TagQueryResponseSchema = z.lazy(
  () => getApiV1Tag200Schema,
) as unknown as ToZod<GetApiV1TagQueryResponse>;
